import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { formatDate } from '../../../common/utils';
import { createLeadOppRelationship } from '../../../common/api';
import { toast } from 'react-toastify';
import { Typeahead } from 'react-bootstrap-typeahead';

import '../modals.css';


const AddLeadOppRelationship = ( { uid, contacts, close, lo } ) => {
    const [ cid, setCid ] = useState( [] );
    const [ searchList, setSearchList ] = useState( [] );
    const [ ready, setReady ] = useState( false );

    const create = async () => {
        // console.log( 'Create LOR', lo.details.aid, uid, lo.details.loid, cid[0].cid );
        const added = await createLeadOppRelationship( lo.details.aid, uid, lo.details.loid, cid[0].cid );
        if ( added.length ) {
            toast.success( `The Lead Opp Relationship has been added`, { theme: 'dark' } );
            close();
        } else {
            toast.error( `There was an error adding the Lead Opp Relationship`, { theme: 'dark' } );
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        if ( cid && cid.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ cid ] );

    useEffect( () => {
        let list = [];
        if ( contacts ) {
            const cur = [];
            if ( lo && lo.members ) {
                lo.members.forEach( m => {
                    cur.push( m.cid );
                } );
            }

            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];
                if ( !c || c.priRole !== 'borrower' || c.aid !== lo.details.aid || cur.includes( c.cid ) ) {
                    return;
                }

                list.push( {
                    id: c.cid,
                    cid: c.cid,
                    firstname: c.firstname,
                    lastname: c.lastname,
                    name: c.name,
                    email: c.email,
                    email2: c.email2,
                    phone: c.phone,
                    phoneMobile: c.phoneMobile,
                    phoneWork: c.phoneWork,
                    firstnamePartner1: c.firstnamePartner1,
                    lastnamePartner1: c.lastnamePartner1,
                    emailPartner1: c.emailPartner1,
                    phonePartner1: c.phonePartner1,
                    firstnamePartner2: c.firstnamePartner2,
                    lastnamePartner2: c.lastnamePartner2,
                    emailPartner2: c.emailPartner2,
                    phonePartner2: c.phonePartner2
                } );
            } );
        }
        setSearchList( list );
    }, [ contacts, lo ] );

    
    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Add a Borrower to this Opportunity</Col>
                </Row>
                <Row className='pt-3 pb-2'>
                    <Col>
                        <Form.Group>
                            <Form.Label>Borrower:</Form.Label>
                            <Typeahead
                                filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                id="tf-lor-finder"
                                labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                onChange={setCid}
                                selected={cid}
                                options={ searchList }
                                placeholder="Search Contacts..."
                                renderMenuItemChildren={ ( option ) => (
                                    <div>
                                        {option.firstname + ' ' + option.lastname}
                                        <div>
                                            <small>Email: {option.email}</small>
                                        </div>
                                    </div>
                                )}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                    </Col>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    uid: state.user.email,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddLeadOppRelationship );